/**
 * Saved User Remapper
 * Flutter: lib/data/models/saved_user.dart
 */
import type { SavedUserDto } from '@/data/dtos/savedUser/savedUserDto';
import type { JsonObject } from '@/data/types/json';
import type { SavedUserStorage } from '@/domain/entities/secureStorage/secureStorageEntities';

export class SavedUserRemapper {
  static toStorage(dto: SavedUserDto): SavedUserStorage {
    return {
      firebaseId: dto.firebaseId,
      createdDate: dto.createdDate,
    };
  }

  static fromJson(data: JsonObject): SavedUserDto {
    return {
      firebaseId: (data['firebaseId'] as string | undefined) ?? '',
      createdDate: (data['createdDate'] as number | undefined) ?? 0,
    };
  }

  static fromJsonList(dataList: JsonObject[]): SavedUserDto[] {
    return dataList.map(SavedUserRemapper.fromJson);
  }
}
